/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * Opaque VGS or supplier token references only; raw card fields are not accepted.
 * @export
 * @interface FlightBookingPayment
 */
export interface FlightBookingPayment {
  /**
   *
   * @type {string}
   * @memberof FlightBookingPayment
   */
  paymentMethodToken: string;
  /**
   *
   * @type {string}
   * @memberof FlightBookingPayment
   */
  authenticationReference: string | null;
}

/**
 * Check if a given object implements the FlightBookingPayment interface.
 */
export function instanceOfFlightBookingPayment(
  value: object
): value is FlightBookingPayment {
  if (
    !("paymentMethodToken" in value) ||
    value["paymentMethodToken"] === undefined
  )
    return false;
  if (
    !("authenticationReference" in value) ||
    value["authenticationReference"] === undefined
  )
    return false;
  return true;
}

export function FlightBookingPaymentFromJSON(json: any): FlightBookingPayment {
  return FlightBookingPaymentFromJSONTyped(json, false);
}

export function FlightBookingPaymentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightBookingPayment {
  if (json == null) {
    return json;
  }
  return {
    paymentMethodToken: json["payment_method_token"],
    authenticationReference: json["authentication_reference"],
  };
}

export function FlightBookingPaymentToJSON(json: any): FlightBookingPayment {
  return FlightBookingPaymentToJSONTyped(json, false);
}

export function FlightBookingPaymentToJSONTyped(
  value?: FlightBookingPayment | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    payment_method_token: value["paymentMethodToken"],
    authentication_reference: value["authenticationReference"],
  };
}
